<template>
	<div class="row align-center upcoming" v-if="list.showUpcoming">
		<div class="small-12 medium-5 large-3 columns">
			<a href="#" @click.prevent="increaseMaxIterations" class="expanded button">More Upcoming Races</a>
		</div>
	</div>
	<div v-el:offset-root class="race-list" :class="class" :id="id">
		<template v-if="races.length > 0 || $loadingAsyncData || emptyText">
			<div class="race-schedule-header" :class="class" data-abr-stickyy data-replace="raceListHeaders">
				<div class="row">
					<div class="small-12 columns header">
						<h4>{{ title }}</h4>
					</div>
				</div>
			</div>
			<div v-if="$loadingAsyncData" class="empty-center show-for-mobile">
				<span>Loading Races...</span>
			</div>
			<div v-if="emptyText && !$loadingAsyncData && races.length <= 0"
			     class="empty-center show-for-mobile">
				<span>No Races Available</span>
			</div>
			<div v-if="!$loadingAsyncData">
				<race-list-date v-ref:dates v-for="date in groupedRaces" :races="date.races" :date="date.date" :group="randomID"></race-list-date>
			</div>
		</template>
	</div>
</template>

<script>
	import Util from './../util'
	import RaceListDate from './RaceListDate.vue'
	import Races from './../store/Races'
	import _ from 'underscore'
	import moment from 'moment'
	import randomstring from 'randomstring'
	import deepClone from 'object-assign-deep'
	import Q from 'q'
	import { MYSQL_FORMAT } from './../mock/RaceLists.js'
	import DaysInRacing from './../store/DaysInRacing'
	import Cache from './../store/Cache.js'
    export default {
	    components: { RaceListDate },
	    props: [ 'list', 'class', 'id', 'emptyText' ],
	    data: function() {
		    return {
			    races: [],
			    daysInRacing: [],
			    message: 'Loading',
			    randomID: randomstring.generate(7),
			    selfOffset: 0,
			    dateOffsets: [],
			    offsetCalculateInterval: null,
			    scrollActive: false
		    }
	    },
	    watch: {
		    list: 'reloadAsyncData',
		    races: function () {
			    window.jQuery(document).trigger('abr-sticky');
			    window.jQuery(document).trigger('reSVG');
		    }
	    },
	    methods: {
		    increaseMaxIterations: function () {
			    if (this.$loadingAsyncData) return;
			    this.races = [];
			    this.list.maxIterations++;
			    this.reloadAsyncData();
		    },
		    calculateSelfOffset: function () {
			    var self = this;
			    var windowOffset = window.pageYOffset;
			    if (!self.$els.offsetRoot) return;
			    self.selfOffset = self.$els.offsetRoot.getBoundingClientRect().top + windowOffset;
			    self.$dispatch('update-debug-value', self.title, self.selfOffset);
			    self.dateOffsets = [];
			    _.each(self.$refs.dates, function (date) {
				    if (!date.$els.offsetRoot) return;
				    var offset = date.$els.offsetRoot.getBoundingClientRect().top + windowOffset;
				    self.dateOffsets.push({
					    date: date.date,
					    offset: offset
				    });
				    self.$dispatch('update-debug-value', self.title + ' - ' + date.date.format('MMM D'), offset);
			    });
			    self.dateOffsets = _.sortBy(self.dateOffsets, 'offset').reverse();
		    },
		    getActiveDate: function (offset) {
			    var self = this;
			    if (offset < self.selfOffset) return false;
			    var activeDateOffsetIndex = false;
			    for (var dateOffsetIndex in self.dateOffsets) {
				    if (!self.dateOffsets.hasOwnProperty(dateOffsetIndex)) continue;
				    var dateOffset = self.dateOffsets[dateOffsetIndex];
				    if (dateOffset.offset > offset) {
					    activeDateOffsetIndex = parseInt(dateOffsetIndex, 10);
				    }
			    }

			    if (activeDateOffsetIndex !== false && typeof(self.dateOffsets[activeDateOffsetIndex + 1]) !== 'undefined') {
				    return self.dateOffsets[activeDateOffsetIndex + 1].date;
			    } else if (activeDateOffsetIndex !== false)
				    return self.dateOffsets[activeDateOffsetIndex].date;
			    else if (typeof(self.dateOffsets['0']) !== 'undefined')
				    return self.dateOffsets['0'].date;
			    else return false;
		    }
	    },
	    ready: function () {
		    this.calculateSelfOffset();
		    window.addEventListener('resize', this.calculateSelfOffset);
		    this.offsetCalculateInterval = setInterval(this.calculateSelfOffset, 1000);
	    },
	    beforeDestroy: function () {
		    window.removeEventListener('resize', this.calculateSelfOffset);
		    clearInterval(this.offsetCalculateInterval);
	    },
	    asyncData: function () {

		    var self = this;

		    // If caching is enabled on the list and there are races
		    // in the cache, create a promise that resolves immediately.
		    var promise = null;
		    var args = this.list.arguments(this.list, this.races);
		    if (this.list.cache) {

			    promise = Q.promise(function (resolve, reject, notify) {
				    Cache.get(self.list.cache, function (err, value) {
					    if (value) {
						    resolve(value);
					    } else {
						    Races.getInstance().fetch(args).then(function (results) {
							    Cache.set(self.list.cache, results);
							    resolve(results);
						    }).done();
					    }
				    });
			    });

		    } else {

			    // Prepare the arguments for the list and get the initial promise.
			    promise = Races.getInstance().fetch(args);

		    }

		    // Add any filters from the filterPrepend array.
		    if (typeof(self.list.filterPrepend) !== 'undefined') {
			    _.each(self.list.filterPrepend, function (filter) {
				    promise = promise.then(filter);
			    });
		    }

		    // Apply list filters.
		    if (typeof(self.list.filters) === 'function') {
			    var filters = self.list.filters(self.list);
			    if (Array.isArray(filters)) {
				    _.each(filters, function (filter) {
					    promise = promise.then(filter);
				    });
			    }
		    }

		    // Add the list fail hook.
		    if (typeof(self.list.fail) === 'function') {
			    promise = promise.fail(function () {
				    self.list.fail(self.list);
			    });
		    }

		    // Add any filters from the filterAppend array.
		    if (typeof(self.list.filterAppend) !== 'undefined') {
			    _.each(self.list.filterAppend, function (filter) {
				    promise = promise.then(filter);
			    });
		    }

		    // Only grab the top 3 starts if we have a race in final.
		    promise = promise.then(function (result) {
			    _.each(result, function (race) {
				    if (race.field_status == '3') {
					    race.start = race.start.slice(0, 3);
				    }
			    });
			    return result;
		    });

		    // Let the parent know the races are loaded.
		    promise.fin(function () {
			    self.$dispatch('list-loaded', self.list);
		    });

		    // Return the final result.
		    return promise.then(function (result) {
			    _.each(result, function (race) {
				    self.races.push(race);
			    });
		    }, function (error) {
			    if (typeof(error.response) !== 'undefined' && error.response.statusCode === 404) {
				    return { message: 'No races found' };
			    } else {
				    return { message: 'There was an error fetching the races' }
			    }
		    });

	    },
	    computed: {
		    title () {
			    if (typeof(this.list.title) === 'function') {
				    return this.list.title();
			    } else {
				    return this.list.title;
			    }
		    },
		    groupedRaces () {

			    var self = this;
			    if (typeof(this.races) === 'undefined' || this.races.length <= 0) return [];

			    var sortedRaces = [];
			    if (typeof(this.list.sort) !== 'undefined' && this.list.sort == 'asc') {

				    // Sort the races by date and title ascending.
				    sortedRaces = _.sortBy(this.races, function (item) {
					    var date = item.post_time ? item.post_time.getTime() : item.date.getTime();
					    return [date, item.title].join('_');
				    });

			    } else {

				    // Sort the races by date desc and title asc.
				    sortedRaces = this.races.sort(function (a, b) {
					    var date_a = a.post_time ? a.post_time.getTime() : a.date.getTime();
					    var date_b = b.post_time ? b.post_time.getTime() : b.date.getTime();
					    if (moment(date_a).unix() === moment(date_b).unix()) {
						    return a.title.localeCompare(b.title);
					    } else {
						    return date_b - date_a;
					    }
				    });

			    }

			    // Group the races by date.
			    var grouped = _.groupBy(sortedRaces, function (item) {
				    return moment.utc(item.date).startOf('day').unix();
			    });

			    var days = [];
			    _.each(grouped, function (races, unixDate) {

				    // Prepare the date object.
				    var date = {
					    races: races,
					    date: moment(unixDate * 1000)
				    };

				    days.push(date);

			    });

			    // Run the sorting operation again against the date sorted list.
			    days = _.sortBy(days, function (item) { return item.date.unix(); });
			    if (typeof(this.list.sort) === 'undefined' || this.list.sort != 'asc') {
				    days.reverse();
			    }

			    return days;

		    }
	    }
    }
</script>



/** WEBPACK FOOTER **
 ** RaceList.vue?57a1493d
 **/